export const backstage = {
  width: '100%',
  height: '100%',
  position: 'absolute',
  backgroundColor: 'rgba(0,0,0,0.12)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
